import React, { FC } from 'react'
import { LxHandleKeyDown } from '@src/utils/Accessbility'

type LxCancelButtonProps = {
  onCancel: () => void
  label?: string
  classNames?: string
  tabIndex?: number
  ariaLabel?: string
  role?: string
  disabled?: boolean

}

const LxCancelButton: FC<LxCancelButtonProps> = ({ onCancel, label = 'Cancel', classNames = '', tabIndex = 0, ariaLabel = '', role = 'button', disabled = false, }) => {
  return (
    <div
      className={`${classNames.replace(/,/g, ' ')} ${disabled ? 'disabledButton' : ''}`}
      onClick={!disabled ? onCancel : undefined}
      tabIndex={disabled ? -1 : tabIndex}
      onKeyDown={!disabled ? (event) => LxHandleKeyDown(event, onCancel) : undefined}
      aria-label={ariaLabel}
      aria-disabled={disabled}
      role={role}
    >
      <span>{label}</span>
    </div>
  )
}

export default LxCancelButton
